export const finalAndMoreRatingsColors = {
  AAA: "#2E7D32",
  AA: "#4CAF50",
  A: "#9CCC65",
  BBB: "#D4E157",
  BB: "#FFE633",
  B: "#FF9900",
  CCC: "#FFADAD",
  CC: "#FF7070",
  C: "#FF0606",
  D: "#CC0000"
};
